import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import { pl } from "@/locales/pl"

const resources = {
  pl,
}

i18n.use(initReactI18next).init({
  resources,
  lng: "pl",
  defaultNS: "common",
  interpolation: {
    escapeValue: false, // react already safes from xss
    format(value, format, lng) {
      if (format === "lowercase") return value.toLowerCase()
      return value
    },
  },
})

export default i18n
